module.exports = __webpack_public_path__ + "img/brosmind.edfb7dcf.png";